import NotACultPopup from "../../components/NotACultPopup";
import OverflowVideo from "../../components/OverflowVideo";
import PresavePopup from "../../components/PresavePopup";
import Setlist from "../../components/Setlist/Setlist";
import ShareExperience from "../../components/ShareExperience/ShareExperience";
import ShowOption from "../../components/ShareExperience/ShowOption";
import UnreleasedTrackPopup from "../../components/UnreleasedTrackPopup";
import BuyNowPopup from "../../components/BuyNowPopup";
import Showcase from "./Showcase";
import FormPopup from "../../components/FormPopup";
import Music from "./Music";
import Tour from "./Tour";
import Videos from "./Videos";

const Home = () => {
  return (
    <div
      id="home"
      className="relative min-h-screen flex flex-col justify-center items-center"
    >
      {/* Required users to enter site */}
      {/* <PresavePopup /> */}
      {/* <BuyNowPopup /> */}

      {/* BG VIDEO */}
      {/* <OverflowVideo /> */}
      <FormPopup />
      <Showcase />
      <Music />
      <Videos />
      <Tour />

      {/* // ---# SPEAKER */}
      {/* <Setlist /> */}

      {/* // ---# CHILD */}
      {/* <ShareExperience /> */}

      {/* // ---# NOT A CULT */}
      {/* <ShowOption />
      <NotACultPopup /> */}

      {/* // ---# SUPERMAN */}
      {/* <UnreleasedTrackPopup /> */}

      {/* <Tour /> */}
    </div>
  );
};

export default Home;
